'use client';

import { useEffect } from 'react';

import userflow from 'userflow.js';

import { env } from '~/env.mjs';

/**
 * Userflow initialization
 *
 * This module handles the initialization of Userflow.js and provides a way to ensure
 * it's properly initialized before any identification calls are made.
 *
 * - The UserflowInit component should be mounted early in the app lifecycle
 * - Use initializeUserflow() before any userflow.identify() calls
 * - The initialization is async and will only happen once
 */
let isInitialized = false;

export const initializeUserflow = () => {
  if (!isInitialized) {
    userflow.init(env.NEXT_PUBLIC_USERFLOW_TOKEN);
    isInitialized = true;
  }
  return isInitialized;
};

// Render nothing - this component is only included so that the init code
// above will run client-side
export const UserflowInit = () => {
  useEffect(() => {
    void initializeUserflow();
  }, []);

  return null;
};
